/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Internalization constants for Table component
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.12.0
 * @since 1.0.0
 */
import ICommonTranslationTable from '../../types/common/table';

const initTranslationTable: ICommonTranslationTable = {
    all: '',
    close: '',
    error: '',
    from: '',
    loading: '',
    noData: '',
    noValueFilter: '',
    restoreRow: '',
    to: '',
};

export default initTranslationTable;
